var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('header',[_c('div',{staticClass:"backBtn",on:{"click":_vm.backEvent}},[_c('img',{attrs:{"src":require("../assets/images/back.png"),"alt":""}})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.msg))]),_c('div',{staticStyle:{"width":"auto","opacity":"0"}},[_vm._v(" 123")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }